import type { DateRange } from 'react-day-picker'

export const getTimeDiffFromNow = (date: Date) => {
  const now = new Date()
  const diff = now.getTime() - date.getTime()
  const diffInMinutes = diff / (1000 * 60)
  const diffInHours = diff / (1000 * 3600)
  const diffInDays = diff / (1000 * 3600 * 24)
  const diffInMonths = diff / (1000 * 3600 * 24 * 30)
  const diffInYears = diff / (1000 * 3600 * 24 * 365)

  if (diffInMinutes < 1) {
    return 'just now'
  }
  if (diffInHours < 1) {
    return `${Math.floor(diffInMinutes)} minutes ago`
  }
  if (diffInDays < 1) {
    return `${Math.floor(diffInHours)} hours ago`
  }
  if (diffInDays < 2) {
    return 'yesterday'
  }
  if (diffInMonths < 1) {
    return `${Math.floor(diffInDays)} days ago`
  }
  if (diffInYears < 1) {
    return `${Math.floor(diffInMonths)} months ago`
  }

  if (diffInYears < 2) {
    return `1 year ago`
  }

  return `${Math.floor(diffInYears)} years ago`
}

export const handleDateRange = (
  dataRange: DateRange,
): Record<'from' | 'to', Date> => {
  const { from, to } = dataRange

  return {
    from: new Date(Math.min(from?.getTime() ?? 0, to?.getTime() ?? 0)),
    to: new Date(Math.max(from?.getTime() ?? 0, to?.getTime() ?? 0)),
  }
}
